if (!customElements.get('localization-info-banner')) {
  customElements.define(
    'localization-info-banner',
    class LocalizationInfoBanner extends HTMLElement {
      constructor() {
        super();

        this.trap = window.traps.store['localization-info-tray'];
      }

      connectedCallback() {
        if (window.getCookie('viewed-localization-content') === 'true') {
          window.setCookie('viewed-localization-content', 'true', 24);
          return;
        }

        window.addEventListener('localization-info-activate', () => {
          if (window.getCookie('viewed-localization-content') === 'true') return;

          setTimeout(() => {
            this.trap?.activate();
            window.setCookie('viewed-localization-content', 'true', 24);
          }, 250);
        });
      }
    },
  );
}
